import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shrigondabusrental() {



  const cardData =
  {
    keyword: 'Shrigonda Bus Rental',
    heading: 'Sanavi Travels: Shrigonda Bus Rental',
    headingDescription: 'Sanavi Travels offers dependable Shrigonda Bus Rental services, providing safe, comfortable, and cost-effective transportation for families, groups, corporate travel, school trips, weddings, picnics, religious tours, and outstation journeys. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures smooth rides, spacious seating, and ample luggage capacity for a hassle-free experience. With professional drivers, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Shrigonda bus rental services are ideal for local travel, sightseeing tours, and long-distance trips. Choose Sanavi Travels for trusted bus rental services in Shrigonda, delivering comfort, safety, and reliability for every journey.',

    top: 'Top Places to Visit in Shrigonda with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shrigonda Town",
    "description": "Shrigonda is a taluka in Ahmednagar district, Maharashtra, known for its agricultural significance and scenic surroundings. Situated amidst fertile plains and gentle hills, Shrigonda offers a glimpse into rural Maharashtrian life, traditional farming practices, and local culture. The town is a blend of history, spirituality, and natural beauty, making it an offbeat destination for travelers seeking authenticity."
  },
  {
    "title": "Shri Khandoba Temple",
    "description": "Shrigonda is home to a prominent Khandoba Temple, dedicated to Lord Khandoba, an incarnation of Lord Shiva. The temple attracts devotees from nearby villages and towns, especially during festivals, and reflects traditional Maharashtrian temple architecture with intricate carvings and a serene atmosphere."
  },
  {
    "title": "Agricultural Fields and Rural Life",
    "description": "The region around Shrigonda is primarily agricultural, cultivating sugarcane, jowar, and pulses. Visitors can explore rural landscapes, interact with local farmers, and experience the simplicity of village life, along with traditional customs and festivals."
  },
  {
    "title": "Local Markets",
    "description": "Shrigonda’s local markets offer fresh produce, handicrafts, and essential goods. These bustling markets give a sense of rural commerce and provide an opportunity to experience local culinary delights and community interactions."
  },
  {
    "title": "Nearby Forts and Heritage Sites",
    "description": "The taluka is surrounded by historical forts and ruins that reflect Maratha and earlier dynasties’ heritage. Though lesser-known, these sites offer trekking, photography, and a chance to explore Maharashtra’s rich historical legacy."
  },
  {
    "title": "Temghar Ghat (Nearby)",
    "description": "Shrigonda provides access to nearby ghats and hill passes such as Temghar Ghat, offering scenic landscapes, monsoon waterfalls, and trekking opportunities. The natural beauty of these ghats attracts nature enthusiasts and adventure seekers."
  },
  {
    "title": "Festivals and Cultural Events",
    "description": "Shrigonda celebrates local festivals with devotion and enthusiasm, including Ganesh Chaturthi, Shiv Jayanti, and Khandoba Utsav. These events feature traditional music, folk dances, and communal rituals, providing visitors an authentic cultural experience."
  },
  {
    "title": "Rivers and Water Bodies",
    "description": "Small rivers and streams flow through Shrigonda, contributing to agriculture and natural beauty. These water bodies become especially scenic during the monsoon, offering calm spots for relaxation and photography."
  },
  {
    "title": "Village Temples and Spiritual Sites",
    "description": "Apart from the main Khandoba temple, Shrigonda taluka has numerous small village shrines and temples dedicated to local deities. These sites reflect traditional faith practices and offer peaceful spiritual retreats for devotees and travelers."
  },
  {
    "title": "Eco-Tourism and Nature Trails",
    "description": "Shrigonda’s rural landscapes, hills, and forests provide opportunities for eco-tourism, trekking, and nature trails. Visitors can enjoy birdwatching, exploring local flora and fauna, and experiencing the serene countryside."
  }
]
,



"services": [
{
"name": "Shrigonda Bus Rental",
"description": "Shrigonda Bus Rental provides reliable, comfortable, and spacious buses for all types of group travel needs. Ideal for families, tourists, corporate teams, and event groups, this service ensures safe and smooth journeys with well-maintained vehicles and experienced drivers. Whether it is local travel, long-distance trips, or special occasions, Shrigonda Bus Rental focuses on comfort, punctuality, and customer satisfaction throughout the journey."
},
{
"name": "Bus Rental Service Shrigonda",
"description": "Bus Rental Service Shrigonda offers flexible and convenient bus rental solutions for weddings, corporate events, sightseeing tours, and outstation travel. With clean interiors, comfortable seating, and professional chauffeurs, this service guarantees a hassle-free travel experience. It is designed to meet the transportation needs of small and large groups with reliability and affordability."
},
{
"name": "AC Bus Rental Shrigonda",
"description": "AC Bus Rental Shrigonda ensures a cool, comfortable, and relaxing journey with fully air-conditioned buses. Perfect for long-distance travel, corporate trips, and family outings, these buses provide spacious seating, smooth rides, and professional drivers. Passengers can enjoy a refreshing travel experience even during hot weather conditions."
},
{
"name": "Luxury Bus Rental Shrigonda",
"description": "Luxury Bus Rental Shrigonda delivers premium travel experiences with stylish interiors, plush seating, and modern amenities. Ideal for weddings, VIP travel, corporate events, and special occasions, this service offers a perfect blend of comfort, elegance, and safety, making every journey memorable and stress-free."
},
{
"name": "Wedding Bus Rental Shrigonda",
"description": "Wedding Bus Rental Shrigonda provides elegant and spacious buses for transporting wedding guests comfortably and on time. With professional drivers, organized scheduling, and clean interiors, it ensures smooth and stress-free transportation for families and guests, adding convenience and reliability to wedding celebrations."
},
{
"name": "Corporate Bus Rental Shrigonda",
"description": "Corporate Bus Rental Shrigonda offers dependable transportation solutions for employee commutes, corporate outings, meetings, and events. Designed for comfort and efficiency, these buses feature professional chauffeurs, punctual service, and spacious seating, ensuring smooth and organized corporate travel."
},
{
"name": "Outstation Bus Rental Shrigonda",
"description": "Outstation Bus Rental Shrigonda provides safe and comfortable long-distance travel for families, groups, and corporate clients. Ideal for pilgrimages, weekend trips, and intercity journeys, these buses are driven by experienced chauffeurs and maintained to high safety standards for a pleasant travel experience."
},
{
"name": "Affordable Bus Rental Shrigonda",
"description": "Affordable Bus Rental Shrigonda offers budget-friendly travel solutions without compromising on comfort or safety. Suitable for families, groups, and organizations, it provides reliable buses, professional drivers, and transparent pricing, making it a cost-effective choice for weddings, tours, and long-distance travel."
},
{
"name": "Chauffeur Driven Bus Shrigonda",
"description": "Chauffeur Driven Bus Shrigonda ensures a hassle-free and relaxed journey with trained drivers handling routes, traffic, and schedules. Ideal for corporate travel, family trips, weddings, and group tours, this service guarantees safe, smooth, and punctual transportation for all passengers."
},
{
"name": "Best Bus Rental Shrigonda",
"description": "Best Bus Rental Shrigonda is known for high-quality buses, professional service, and timely travel arrangements. Perfect for weddings, corporate events, sightseeing tours, and outstation journeys, it focuses on passenger comfort, safety, and reliability, making it a trusted choice for group transportation."
},
{
"name": "Tourist Bus Rental Shrigonda",
"description": "Tourist Bus Rental Shrigonda caters to travelers exploring Shrigonda and nearby destinations. With comfortable seating, knowledgeable drivers, and flexible itineraries, it provides a convenient and enjoyable travel experience for sightseeing tours, pilgrimages, and leisure trips."
},
{
"name": "Group Travel Bus Shrigonda",
"description": "Group Travel Bus Shrigonda offers organized and dependable transportation for families, friends, corporate teams, and tour groups. Spacious buses, professional drivers, and punctual service ensure smooth, safe, and comfortable journeys, making group travel easy and well-coordinated."
},
{
"name": "Online Bus Booking Shrigonda",
"description": "Online Bus Booking Shrigonda allows travelers to easily reserve buses with instant confirmation and flexible scheduling. Multiple bus options, secure payment methods, and quick booking make travel planning simple and convenient for weddings, corporate events, tours, and group travel."
},
{
"name": "Event Bus Rental Shrigonda",
"description": "Event Bus Rental Shrigonda provides dedicated transportation for weddings, corporate gatherings, social functions, and special events. With reliable buses, professional drivers, and timely service, it ensures organized, safe, and comfortable travel for all event attendees."
},
{
"name": "Shrigonda Travel Bus",
"description": "Shrigonda Travel Bus offers complete bus travel solutions for local travel, outstation journeys, weddings, corporate events, and tourist trips. With well-maintained vehicles, experienced drivers, and customer-focused service, it guarantees safe, comfortable, and hassle-free travel across Shrigonda and nearby regions."
}
],
"tableData": [
["Shrigonda Bus Rental", "Bus Rental Service Shrigonda"],
["AC Bus Rental Shrigonda", "Luxury Bus Rental Shrigonda"],
["Wedding Bus Rental Shrigonda", "Corporate Bus Rental Shrigonda"],
["Outstation Bus Rental Shrigonda", "Affordable Bus Rental Shrigonda"],
["Chauffeur Driven Bus Shrigonda", "Best Bus Rental Shrigonda"],
["Tourist Bus Rental Shrigonda", "Group Travel Bus Shrigonda"],
["Online Bus Booking Shrigonda", "Event Bus Rental Shrigonda"],
["Shrigonda Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Shrigonda Bus Rental with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Shrigonda, perfect for group outings, family trips, school tours, corporate travel, and pilgrimages."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Shrigonda and surrounding areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with routes in and around Shrigonda, ensuring safe, punctual, and stress-free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront and clear pricing for bus rentals in Shrigonda, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Shrigonda bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rental in Shrigonda."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Shrigonda?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Shrigonda for various travel needs.'
  },
  {
    question: 'How can I book a bus in Shrigonda?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Shrigonda?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Shrigonda?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Shrigonda routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations in Shrigonda?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Shrigonda and nearby areas.'
  },
  {
    question: 'Is the bus rental service in Shrigonda available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus rental services in Shrigonda to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Shrigonda.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prashant Patil',
    feedback: 'We rented a bus in Shrigonda from Sanavi Travels — very comfortable journey and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aishwarya More',
    feedback: 'Sanavi Travels provided a clean and reliable bus for our Shrigonda trip. Highly recommended!',
    rating: 5
  }
];











































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Shrigonda Bus Rental - Sanavi Travels",
  "description": "Book a bus rental in Shrigonda with Sanavi Travels. We provide AC and luxury buses for weddings, corporate trips, outstation tours, group travel, events, and tourist trips. Affordable and chauffeur-driven buses with hassle-free online booking.",
  "touristType": "Wedding, Corporate, Outstation, Group Travel, Tourist",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "22"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Shrigonda Bus Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Rent a bus in Shrigonda with Sanavi Travels. AC and luxury buses for weddings, corporate trips, outstation tours, group travel, and events. Affordable and chauffeur-driven buses with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/192.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Shrigondabusrental;